var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapWalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.174,
    cy: 3.874,
    r: 1.745
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.233,9.474l-2.887-.269-1.987-2.36c-.331-.393-.847-.577-1.351-.484l-3.663.678c-.344.064-.633.294-.772.615l-1.42,3.291c-.182.423-.016.929.399,1.129.12.058.246.085.369.085.329,0,.642-.192.781-.513l1.294-2.998,1.13-.209-.365,2.87.128.063-.36,3.453c-.035.338-.177.656-.405.907l-2.833,3.124c-.315.348-.289.885.059,1.201.348.315.885.289,1.201-.059l3.206-3.536c.228-.252.37-.569.405-.907l.239-2.297,1.83,1.656c.309.28.496.669.522,1.085l.317,5.076c.028.45.402.797.848.797.018,0,.036,0,.054-.002.469-.029.825-.433.795-.901l-.36-5.766c-.026-.416-.213-.805-.522-1.085l-1.711-1.548v-3.302s1.042,1.238,1.042,1.238c.177.211.431.343.705.369l3.181.296c.473.044.891-.308.926-.784.035-.467-.331-.868-.797-.912Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapWalk);
export default __webpack_public_path__ + "static/media/map-walk.e003639515c87ec6be343167d8ed6175.svg";
export { ForwardRef as ReactComponent };